const WORKER_URL = import.meta.env.VITE_WORKER_URL ?? "http://localhost:8787";

// The Newsstand's wire (design_documents/news.md): the worker merges the
// category feeds into { fetched_at, sources, items }. The last good issue is
// kept on the device so the Newsstand opens offline and Home can show the lead
// headline without a network call.

const LAST_KEY = "newsstand:last";

export function cachedNews() {
	try {
		const raw = localStorage.getItem(LAST_KEY);
		return raw ? JSON.parse(raw) : null;
	} catch {
		return null;
	}
}

// Fresh news, falling back to the cached issue when offline or the worker
// fails. Resolves { data, stale } (stale = served from the device copy).
export async function getNews({ signal } = {}) {
	try {
		const resp = await fetch(`${WORKER_URL}/news`, { signal });
		if (!resp.ok) throw new Error(`Request failed: ${resp.status}`);
		const data = await resp.json();
		try {
			localStorage.setItem(LAST_KEY, JSON.stringify(data));
		} catch {
			// storage full / unavailable — fine, just no offline copy
		}
		return { data, stale: false };
	} catch (err) {
		if (err?.name === "AbortError") throw err;
		const cached = cachedNews();
		if (cached) return { data: cached, stale: true };
		throw err;
	}
}
